/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataLoaderParamsBasic } from '../models/DataLoaderParamsBasic';
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { SurveyJobFamily } from '../models/SurveyJobFamily';
import type { SurveyJobLevel } from '../models/SurveyJobLevel';
import type { SurveyJobProfile } from '../models/SurveyJobProfile';
import type { SurveyJobProfileCreateRequest } from '../models/SurveyJobProfileCreateRequest';
import type { SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkRequest } from '../models/SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkRequest';
import type { SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkResponse } from '../models/SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkResponse';
import type { SurveyJobProfileUpdateRequest } from '../models/SurveyJobProfileUpdateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSurveyJobProfileService {

    /**
     * get list of SurveyJobProfiles
     * @returns SurveyJobProfile Success
     * @throws ApiError
     */
    public static listAdminSurveyJobProfiles({
        surveyVendorId,
        planId,
        limit,
        offset,
        ignorePagination,
        search,
    }: {
        /**
         * Survey Vendor ID
         */
        surveyVendorId?: (number | string | null),
        /**
         * Plan ID
         */
        planId?: (number | string | null),
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * ignore Pagination flag
         */
        ignorePagination?: boolean,
        /**
         * Search by name or code
         */
        search?: string,
    }): CancelablePromise<Array<SurveyJobProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile',
            query: {
                'surveyVendorId': surveyVendorId,
                'planId': planId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create SurveyJobProfile
     * @returns any Success
     * @throws ApiError
     */
    public static createSurveyJobProfile({
        requestBody,
    }: {
        requestBody?: SurveyJobProfileCreateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyJobProfile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Edit SurveyJobProfile
     * @returns SurveyJobProfile Success
     * @throws ApiError
     */
    public static edit({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: SurveyJobProfileUpdateRequest,
    }): CancelablePromise<SurveyJobProfile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/surveyJobProfile/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete SurveyJobProfile
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyJobProfile({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/surveyJobProfile/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Append SurveyJobProfile file
     * @returns any Success
     * @throws ApiError
     */
    public static appendSurveyJobProfileFile({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: DataLoaderParamsBasic,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyJobProfile/{id}/append',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Download SurveyJobProfile file
     * @returns string Success
     * @throws ApiError
     */
    public static downloadSurveyJobProfileFile({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Download Rollup Map for SurveyJobProfile
     * @returns string Success
     * @throws ApiError
     */
    public static downloadSurveyJobProfileRollupMap({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/downloadRollupMap',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reload SurveyJobProfile
     * @returns any Success
     * @throws ApiError
     */
    public static reloadAll({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: DataLoaderParamsBasic,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyJobProfile/{id}/reload',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of SurveyJobProfileJobDefinitions
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyJobProfileJobDefinitions({
        id,
        jobFamily,
        jobSubFamily,
        jobFocus,
        jobLevel,
        search,
        mapped,
        surveyJobProfileId,
        onlyWithRecommendations,
        recommendationType,
        limit,
        offset,
        sort,
    }: {
        /**
         * SurveyJobProfile ID
         */
        id: string,
        /**
         * jobFamily IDs
         */
        jobFamily?: Array<string>,
        /**
         * jobSubFamily IDs
         */
        jobSubFamily?: Array<string>,
        /**
         * jobFocus IDs
         */
        jobFocus?: Array<string>,
        /**
         * jobLevel IDs
         */
        jobLevel?: Array<string>,
        /**
         * search
         */
        search?: string | null,
        /**
         * mapped
         */
        mapped?: string,
        /**
         * surveyJobProfile Id
         */
        surveyJobProfileId?: string,
        /**
         * is show only job with recommendations
         */
        onlyWithRecommendations?: boolean,
        /**
         * recommendation type
         */
        recommendationType?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Order Options
         */
        sort?: Record<string, any>,
    }): CancelablePromise<{
        rows?: Array<DHSurveyJobDefinition>;
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/jobDefinitions',
            path: {
                'id': id,
            },
            query: {
                'jobFamily': jobFamily,
                'jobSubFamily': jobSubFamily,
                'jobFocus': jobFocus,
                'jobLevel': jobLevel,
                'search': search,
                'mapped': mapped,
                'surveyJobProfileId': surveyJobProfileId,
                'onlyWithRecommendations': onlyWithRecommendations,
                'recommendationType': recommendationType,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of levels for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static adminListLevels({
        id,
    }: {
        /**
         * SurveyJobProfile ID
         */
        id: string,
    }): CancelablePromise<{
        count?: number;
        rows?: Array<SurveyJobLevel>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/jobLevels',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of families for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static adminListFamilies({
        id,
    }: {
        /**
         * SurveyJobProfile ID
         */
        id: string,
    }): CancelablePromise<{
        count?: number;
        rows?: Array<SurveyJobFamily>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/jobFamilies',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Download SurveyModuleJobs for the profile
     * @returns string Success
     * @throws ApiError
     */
    public static downloadSurveyModuleJobs({
        id,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyJobProfile/{id}/downloadSurveyModuleJobs',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get missing category level codes csv link
     * @returns SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkResponse Success
     * @throws ApiError
     */
    public static getMissingCategoryLevelCodesCsvLink({
        id,
        requestBody,
    }: {
        /**
         * Survey Job Profile ID
         */
        id: string,
        requestBody: SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkRequest,
    }): CancelablePromise<SurveyJobProfileGetMissingCategoryLevelCodesCsvLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyJobProfile/{id}/getMissingCategoryLevelCodesCsvLink',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
